<template>
    <div class='box'>
  <div class="row">
<div class="col-lg-5">
  <div class="center" v-if="loading">
   <i class="fa fa-spin fa-spinner fa-5x"></i>
  </div>
  <div v-else>
    <va-chart
              :chart-config='chartData'
    >
            </va-chart>
  </div>
  </div>
  <div class="col-lg-7">
     <div class="center" v-if="loading_case">
   <i class="fa fa-spin fa-spinner fa-5x"></i>
  </div>
  <div v-else>
      <p class='text-center'>
              <strong>{{$t('case_summary')}} : {{caseSummary.total}}</strong>
            </p>
    <div class="col-lg-6">
       <P class='text-center'><i class="fa fa-male fa-2x text-primary"></i><br>{{caseSummary.male}}</P>
<va-chart
              :chart-config='chartCaseDataMale'></va-chart>
               
    </div>
    <div class="col-lg-6">
<P class='text-center'><i class="fa fa-female fa-2x text-warning"></i><br>{{caseSummary.female}}</P>
<va-chart
              :chart-config='chartCaseDataFemale'></va-chart>
              
    </div>
    </div>
  </div>
  </div>
  <div class="row">
    
 <div class="center" v-if="loading_age">
   <i class="fa fa-spin fa-spinner fa-5x"></i>
  </div>
  <div v-else>
 <div class="border-top my-3" style="border-top:1"></div>

    
              <h2 class='text-center'>{{$t('age_group_request')}} :{{ageSummary.total}}</h2>

    <div class="col-lg-12">
       <P class='text-center'><i class="fa fa-male fa-3x text-primary"></i></P>
<va-chart 
              :chart-config='chartAgeDataMale'></va-chart>
               
    </div>
    
    </div>

  </div>

  <div class="row">
    <h2 class='text-center'>{{$t('location_based_request')}}</h2>
     <div class="center" v-if="loading_location">
   <i class="fa fa-spin fa-spinner fa-5x"></i>
    </div>
    <div v-else>
    <va-chart
              :chart-config='chartLocationData'></va-chart>
    </div>
  </div>
  <div class="clearfix"></div>
    </div>
</template>

<script>
import VAChart from '../components/VAChart'
import { services } from '../../src/vuex/api'
import i18n from '../plugins/i18n' 
export default {
  components: {
    'va-chart':VAChart
  },
  name: 'Users',
   mounted: function () {
     this.locationLevel = this.$route.query.level === undefined ? 0 : this.$route.query.level 
     this.district = this.$route.query.district === undefined ? '' : this.$route.query.district 
     this.state = this.$route.query.state === undefined ? '' : this.$route.query.state 
     this.citty = this.$route.query.citty === undefined ? '' : this.$route.query.citty 
      // alert(this.locationLevel)
      var filter = {level:this.locationLevel ,state:this.state,district:this.district,city:this.city}
     this.getRequestReport(filter)
     this.getRequestCaseReport(filter)
     this.getLocationReport(filter)
     this.getRequestAgeReport(filter)
   },
  data () {
    return {
    loading : false ,
    loading_case: false ,
    loading_age: false ,
    loading_location: false ,
    locationLevel:0,
    state:'',
    district:'',
    city:'',
    chartData:{type:'line',data:{datasets:[]}},
    chartCaseDataMale:{type:'pie',data:{datasets:[]}},
    chartCaseDataFemale:{type:'pie',data:{datasets:[]}},
    chartAgeDataMale:{type:'bar',data:{datasets:[]}},
    chartAgeDataFemale:{type:'bar',data:{datasets:[]}},
    chartDeathDataMale:{type:'bar',data:{datasets:[]}},
    chartDeathDataFemale:{type:'bar',data:{datasets:[]}},
    chartLocationData:{type:'bar',data:{datasets:[]}},
    caseSummary:{total:0,male:0,female:0},
    ageSummary:{total:0,male:0,female:0},
    deathSummary:{total:0,male:0,female:0}
    }
  },
  methods: {
    click(event,array) {
      // console.log(array)
      // console.log(event)
      var area = array[0]._model.label
      var url = '/hotline-report'
      if (parseInt(this.locationLevel) === 0){
        url = '/hotline-report?level=1&state=' + area
      } else if (parseInt(this.locationLevel) === 1) {
        url = `/hotline-report?level=2&state=${this.state}&district=${area}`
      } else if (parseInt(this.locationLevel) === 2){
        url = `/hotline-report?level=3&state=${this.state}&district=${this.district}&city=${area}`
      }
      // alert(this.locationLevel + '   ' + url )
      window.location.href = url
    },
  clickBtn () {
      this.loading = !this.loading
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
    },
    getRequestReport(filter){
       var self = this
      self.loading = true
     services.RequestForRation.getReport(filter ) //  .getPatientInfo()
    .then(function (response) {
      let chartData = response.data
      var datas = []
      var dataLine = []
      var lebels = []
      chartData.forEach(element => {
           var date = element._id.day + '/' + element._id.month + '/' + element._id.year
           lebels.push(date)
            datas.push(element.count  )
            dataLine.push({y:element.count,x:date})
       })
     
      var chart = {
            type: 'line',
            data: {
               labels: lebels,
                datasets: [
                  {
                    label: i18n.t('number_of_request'),
                    data:datas
                  }
                  ]
              },
           stroke: {
             curve: 'straight'
            },
            title: {
              text: i18n.t('case_trend'),
              align: 'left'
            },
            grid: {
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            }
          }
            self.chartData = chart
             self.loading = false
    })
    .catch(function (error) {
      console.log(error)
      self.loading = false
    })
    },
  getRequestCaseReport(filter){
       var self = this
      self.loading_case = true
     services.RequestForRation.getCaseReport(filter ) //  .getPatientInfo()
    .then(function (response) {
      let chartData = response.data
      var datas_male = [0,0,0,0]
      var datas_female = [0,0,0,0]
      var lebels = i18n.t('rationRequestStatus')
      var defaultCase = 0
      chartData.forEach(element => {
        self.caseSummary.total =  self.caseSummary.total  + element.count
        defaultCase = element._id.status === undefined ? 0 : element._id.status
        if (element._id.gender === 0){
          datas_male[defaultCase] = datas_male[defaultCase] + element.count
           self.caseSummary.male =  self.caseSummary.male  + element.count
        } else if (element._id.gender === 1){
          datas_female[defaultCase] = datas_female[defaultCase] + element.count
          self.caseSummary.female =  self.caseSummary.female  + element.count
        }
       })
     
      var BGColor = ['#11baed', '#f2b407', '#1db345','#f50539']
      var HoverColor = ['#11baed', '#f2b407', '#1db345','#f50539']
      var chart_male = {
        type: 'pie',
        data: {
          labels: lebels,
          datasets: [{
            data: datas_male,
            backgroundColor: BGColor,
            hoverBackgroundColor: HoverColor
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      }
      
      var chart_female = {
        type: 'pie',
        data: {
          labels: lebels,
          datasets: [{
            data: datas_female,
             backgroundColor: BGColor,
            hoverBackgroundColor: HoverColor
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      }
            self.chartCaseDataMale = chart_male
            self.chartCaseDataFemale = chart_female
             self.loading_case = false
            // alert('done')
            // console.log('VVVVV CHART VVVVV')
            // console.log(chart_male)
    })
    .catch(function (error) {
      console.log(error)
      self.loading_case = false
    })
    },
    getRequestAgeReport(filter){
       var self = this
      self.loading_age = true
     services.RequestForRation.getStatusReport(filter) //  .getPatientInfo()
    .then(function (response) {
      let chartData = response.data
      var datas_male = [0,0,0,0,0]
      var datas_female = [0,0,0,0,0]
      var datas_male_d = [0,0,0,0,0]
      var datas_female_d = [0,0,0,0,0]
      var datas_male_c = [0,0,0,0,0]
      var datas_female_c = [0,0,0,0,0]
      var lebels = i18n.t('ageGroupRation')
      var ageGroup = 0
      chartData.forEach(element => {
        ageGroup = element._id.ageGroup === undefined ? 0 : element._id.ageGroup
        self.ageSummary.total =  self.ageSummary.total  + element.count
        if (element._id.gender === 0){
           self.ageSummary.male =  self.ageSummary.male  + element.count
           datas_male[ageGroup] = datas_male[ageGroup] + element.count
           if (element._id.status === 2){
             datas_male_d[ageGroup] = datas_male_d[ageGroup] + element.count
           } else if (element._id.status === 3){
             datas_male_c[ageGroup] = datas_male_c[ageGroup] + element.count
           }
        } else if (element._id.gender === 1){
          self.ageSummary.female =  self.ageSummary.female  + element.count
           datas_female[ageGroup] = datas_female[ageGroup] + element.count
           if (element._id.status === 2){
             datas_female_d[ageGroup] = datas_female_d[ageGroup] + element.count
           } else if (element._id.status === 3){
             datas_female_c[ageGroup] = datas_female_c[ageGroup] + element.count
           }
        }
       })
     
      var BGColor = ['#237ff7', '#23f738', '#00c0ef', '#f0df24' , '#f07c24' , '#ed2d1f']
      var BGColorHover = ['#237ff7', '#23f738', '#00c0ef', '#f0df24' , '#f07c24' , '#ed2d1f']
      var chart_male = {
        type: 'bar',
        data: {
          labels: lebels,
          datasets: [
            {
             label:  i18n.t('total_request_male'),
            data: datas_male,
            backgroundColor: BGColor[0],
            hoverBackgroundColor: BGColorHover[0],
            borderColor:'#344ceb',
            borderWidth: 2
           },
           {
             label:  i18n.t('total_delivered_male'),
            data: datas_male_d,
            backgroundColor: BGColor[1],
            hoverBackgroundColor: BGColorHover[1],
             borderColor:'#344ceb',
               borderWidth: 2
           },
           {
             label:  i18n.t('total_canceled_male'),
            data: datas_male_c,
            backgroundColor: BGColor[2],
            hoverBackgroundColor: BGColorHover[2],
             borderColor:'#344ceb',
               borderWidth: 2
           },
           {
             label:  i18n.t('total_request_female'),
            data: datas_female,
            backgroundColor: BGColor[3],
            hoverBackgroundColor: BGColorHover[3],
            borderColor: '#ff3bf2',
            borderWidth: 2
           },
            {
             label:  i18n.t('total_delivered_female'),
            data: datas_female_d,
            backgroundColor: BGColor[4],
            hoverBackgroundColor: BGColorHover[4],
            borderColor: '#ff3bf2',
            borderWidth: 2
           },
            {
             label:  i18n.t('total_cancel_female'),
            data: datas_female_c,
            backgroundColor: BGColor[5],
            hoverBackgroundColor: BGColorHover[5],
            borderColor: '#ff3bf2',
            borderWidth: 2
           }
          ]
        },
        options: {
          scales: {
            xAxes: [{
              stacked: false
            }],
            yAxes: [{
              stacked: false
            }]
          }
        }
      }
      
      var chart_female = {
        type: 'bar',
        data: {
          labels: lebels,
          datasets: [{
             label: self.caseSummary.female,
            data: datas_female,
            backgroundColor: BGColor,
            hoverBackgroundColor: BGColorHover
          }]
        },
        options: {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true
            }]
          }
        }
      }
      
            self.chartAgeDataMale = chart_male
            self.loading_age = false
    })
    .catch(function (error) {
      console.log(error)
      self.loading_age = false
    })
    },
    getLocationReport(filter){
      var self = this
      self.loading_location = true
     services.RequestForRation.getAreaReport(filter ) //  .getPatientInfo()
    .then(function (response) {
      let chartData = response.data
      var datas_total = []
      var datas_delivered = []
      var datas_cancelled = []
      var lebels = []
      var area = ''
      var areaIndex = -1
      var currentIndex = 0
      chartData.forEach(element => {
        area = element._id.area 
        areaIndex = lebels.indexOf(area)
        currentIndex = lebels.length 
        if ( areaIndex === -1 ){
        lebels[currentIndex] = area
        } else {
         currentIndex = areaIndex
       }
        datas_total[currentIndex] = (datas_total[currentIndex] === undefined ? 0 : datas_total[currentIndex]) + element.count
       
        if (element._id.status === 3){
          datas_cancelled[currentIndex] = (datas_cancelled[currentIndex] === undefined ? 0 : datas_cancelled[currentIndex]) + element.count
        } else if (element._id.status  === 2){  
         datas_delivered[currentIndex] = (datas_delivered[currentIndex] === undefined ? 0 : datas_delivered[currentIndex])  + element.count
        }
       })
      var BGColor = ['#ebc634', '#11c255', '#bf0b1d']
      var BGColorHover = ['#eb7434', '#023806', '#63040a']
      var chart_location = {
        type: 'bar',
        data: {
          labels: lebels,
          datasets: [ {
             label:  i18n.t('request'),
            data: datas_total,
            backgroundColor: BGColor[0],
            hoverBackgroundColor: BGColorHover[0],
             borderColor:BGColorHover[0],
               borderWidth: 2
           },
           {
             label:  i18n.t('delivered'),
            data: datas_delivered,
            backgroundColor: BGColor[1],
            hoverBackgroundColor: BGColorHover[1],
             borderColor: BGColorHover[1],
               borderWidth: 2
           },
           {
             label:  i18n.t('canceled'),
            data: datas_cancelled,
            backgroundColor: BGColor[2],
            hoverBackgroundColor: BGColorHover[2],
            borderColor: BGColorHover[2],
            borderWidth: 2
           }]
        },
        options: {
        onClick: function(evt,array) {
        self.click(evt,array)
        },
        scales: {
            xAxes: [{
              stacked: false
            }],
            yAxes: [{
              stacked: false,
               ticks: {
               beginAtZero: true
                }
            }]
          },
        }
      }
    
            self.chartLocationData = chart_location
            self.loading_location = false
    })
    .catch(function (error) {
      console.log(error)
      self.loading_location = false
    })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Report-Hotline.vue?a2077384